import { Component, OnInit, Injector } from '@angular/core';
import { ReportsService, Statuses } from '../reports.service';

@Component({
  selector: 'ga-wo-cancelled-report-form',
  templateUrl: './ga-wo-cancelled-report-form.component.html',
  styleUrls: ['././ga-wo-cancelled-report-form.component.scss',
    '../../../dialogs/ga-wo-submit-report-dialog/ga-wo-submit-report-dialog.component.scss',
    '../../../../work-orders.component.scss']
})
export class GaWoCancelledReportFormComponent implements OnInit {
  service: ReportsService;

  constructor(injector: Injector) {
    this.service = injector.get(ReportsService);
    this.service.status = Statuses.Cancelled;
  }

  ngOnInit() {
    this.service.editForm.get('ActualStartDate').setValue(new Date());
    Promise.all([
      this.service.getStatuses(Statuses.Cancelled),
      this.service.getDefaultContacts(),
      this.service.populateContactsList()
    ]);
  }
}
